import { render, staticRenderFns } from "./InheritRedEnvelope.vue?vue&type=template&id=70accff9&scoped=true&"
import script from "./InheritRedEnvelope.vue?vue&type=script&lang=js&"
export * from "./InheritRedEnvelope.vue?vue&type=script&lang=js&"
import style0 from "./InheritRedEnvelope.vue?vue&type=style&index=0&id=70accff9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70accff9",
  null
  
)

export default component.exports